import React from 'react';

import { styled } from '@mui/material';

import { extractTextMarking } from '../../helper/extract-text-markings';

export type DataGridProps = {
  data: DataProps[];
  className?: string;
};

export type DataProps = {
  smallText: string;
  description: string;
};

export const DataGrid = ({ data, className }: DataGridProps) => (
  <div className={className}>
    <DataContainer>
      {data.map((item, index) => (
        <>
          <DataColumn
            description={item.description}
            smallText={item.smallText}
          />

          {(index + 1) % 3 !== 0 && <ColumnDivider />}
        </>
      ))}
    </DataContainer>
  </div>
);

const DataColumn = ({ smallText, description }: DataProps) => {
  const markedDescription = extractTextMarking(description);

  return (
    <div>
      <Data>{smallText}</Data>
      <Description>
        <strong>{markedDescription.beforeMarking}</strong>
        {markedDescription.marking}
        <strong>{markedDescription.afterMarking}</strong>
      </Description>
    </div>
  );
};

const DataContainer = styled('div')(({ theme }) => ({
  display: 'grid',
  rowGap: 'var(--spacer-xl)',

  [theme.breakpoints.up('sm')]: {
    gridTemplateColumns: '1fr auto 1fr auto 1fr',
    rowGap: 'var(--spacer-xxxl)',
  },
}));

const ColumnDivider = styled('div')(({ theme }) => ({
  display: 'none',

  [theme.breakpoints.up('sm')]: {
    display: 'block',
    margin: '0 var(--spacer-xxl)',
    width: '2px',
    height: '100%',
    backgroundColor: 'var(--color-medium-light-grey)',
  },
}));

const Data = styled('h3')(({ theme }) => ({
  ...theme.typography.h2,
  fontSize: '45px',
  fontWeight: 'var(--font-weight-medium)',
  lineHeight: '100%',
  color: 'var(--color-light-red)',
  margin: '0 0 var(--spacer-m)',

  [theme.breakpoints.up('sm')]: { fontSize: '45px' },
  [theme.breakpoints.up('md')]: { fontSize: '65px' },
  [theme.breakpoints.up('lg')]: { fontSize: '90px' },
}));

const Description = styled('p')(({ theme }) => ({
  ...theme.typography.h6,
  fontSize: '14px',
  fontWeight: 'var(--font-weight-regular)',
  lineHeight: '145%',
  textWrap: 'balance',
  margin: 0,

  strong: {
    ...theme.typography.h4,
    lineHeight: 'inherit',
    fontSize: '18px',

    [theme.breakpoints.up('sm')]: { fontSize: '21px' },
    [theme.breakpoints.up('md')]: { fontSize: '27px' },
    [theme.breakpoints.up('lg')]: { fontSize: '32px' },
  },

  [theme.breakpoints.up('sm')]: {
    fontSize: '16px',
    lineHeight: '130%',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '18px',
    lineHeight: '130%',
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '21px',
  },
}));
